module.exports = __webpack_public_path__ + "static/media/green-tick.6b07ecd3.svg";